import { Guid } from 'src/application/store/model/guid';

import { getItemByIdSelector } from '../../../../store/reducers/items/itemsSelectors';
import { useStudentSelector } from '../../../../store/selectors/useStudentSelector';
import { createCompletionServiceSelector } from '../../services/CompletionService';

export const useTrackingStatus = (itemId: Guid) => {
  const completionService = useStudentSelector(createCompletionServiceSelector);
  const getItemById = useStudentSelector(getItemByIdSelector);
  const item = getItemById(itemId);
  const isComplete = completionService.isComplete(item);
  return {
    evaluationResult: completionService.evaluate(item),
    isComplete,
  };
};
